// ----------------------------------------------------------------------
// Main docready function that will load our other modules
// ----------------------------------------------------------------------
// universal doc ready function
(function(funcName, baseObj) {
  // The public function name defaults to window.docReady
  // but you can pass in your own object and own function name and those will be used
  // if you want to put them in a different namespace
  funcName = funcName || "fowtr_docReady";
  baseObj = baseObj || window;
  var readyList = [];
  var readyFired = false;
  var readyEventHandlersInstalled = false;

  // call this when the document is ready
  // this function protects itself against being called more than once
  function ready() {
    if (!readyFired) {
      // this must be set to true before we start calling callbacks
      readyFired = true;
      for (var i = 0; i < readyList.length; i++) {
        // if a callback here happens to add new ready handlers,
        // the docReady() function will see that it already fired
        // and will schedule the callback to run right after
        // this event loop finishes so all handlers will still execute
        // in order and no new ones will be added to the readyList
        // while we are processing the list
        readyList[i].fn.call(window, readyList[i].ctx);
      }
      // allow any closures held by these functions to free
      readyList = [];
    }
  }

  function readyStateChange() {
    if ( document.readyState === "complete" ) {
      ready();
    }
  }

  // This is the one public interface
  // docReady(fn, context);
  // the context argument is optional - if present, it will be passed
  // as an argument to the callback
  baseObj[funcName] = function(callback, context) {
    if (typeof callback !== "function") {
      throw new TypeError("callback for fowtr_docReady(fn) must be a function");
    }
    // if ready has already fired, then just schedule the callback
    // to fire asynchronously, but right away
    if (readyFired) {
      setTimeout(function() {callback(context);}, 1);
      return;
    } else {
      // add the function and context to the list
      readyList.push({fn: callback, ctx: context});
    }
    // if document already ready to go, schedule the ready function to run
    if (document.readyState === "complete") {
      setTimeout(ready, 1);
    } else if (!readyEventHandlersInstalled) {
      // otherwise if we don't have event handlers installed, install them
      if (document.addEventListener) {
        // first choice is DOMContentLoaded event
        document.addEventListener("DOMContentLoaded", ready, false);
        // backup is window load event
        window.addEventListener("load", ready, false);
      } else {
        // must be IE
        document.attachEvent("onreadystatechange", readyStateChange);
        window.attachEvent("onload", ready);
      }
      readyEventHandlersInstalled = true;
    }
  };
})("fowtr_docReady", window);




fowtr_docReady(function() {



      gsap.registerPlugin(CSSRulePlugin);
      gsap.registerPlugin(AttrPlugin);

      var urlParamsChapterHasJumped = false;      
      var urlParamsSectionHasJumped = false;      
      var currentChapter;



      // internal links
      $('#fowtr-wrapper').on('click', 'a[data-tracking-internal-link]', function(e) {
        e.preventDefault();
        var part = $(this).attr('data-part');
        var section = $(this).attr('data-section');
        loadChapter(part,section);
      });


      // ------------------------------------------------------------------------------------------------
      // CHAPTER LOADING
      // ------------------------------------------------------------------------------------------------


      $("#fowtr-wrapper").on('click','.fowtr-load-chapter', function(e) {
        e.preventDefault();
        var chapter = $(this).attr('data-fowtr-chapter');
        loadChapter(chapter,null);
        // $('#fowtr-loading').fadeIn();
        // $('#fowtr-wrapper').load('fowtr-ch'+chapter+'.html', function(response, status, xhr) {  // callback function 
        //     if ( status == "error" ) {
        //       // var msg = "Sorry but there was an error: ";
        //       // $( "#error" ).html( msg + xhr.status + " " + xhr.statusText );
        //       console.warn('fowtr: Error loading content: ' + xhr.status + " " + xhr.statusText);
        //     } else {
        //       // alert('data loaded');
        //     }
        //     $('#fowtr-loading').fadeOut();
        // });
      });



      // LOAD CHAPTER 1 ON LOAD
      $(window).on('load', function(){

        var loadingChapter = '1';
        currentChapter = loadingChapter;
        // var loadingChapter = '_dev';

        // url inbound jump to
        var urlChapterParam = fowtr_module_utilities.getUrlParameter('part');
        if(urlChapterParam!==false && urlParamsChapterHasJumped==false){
          // if(urlChapterParam=='1' || urlChapterParam=='2' || urlChapterParam=='3'){
          if(urlChapterParam=='1' || urlChapterParam=='2' || urlChapterParam=='3' || urlChapterParam=='4' || urlChapterParam=='_dev'){
            loadingChapter = urlChapterParam;
            urlParamsChapterHasJumped = true;
          }
        }
        loadChapter(loadingChapter,null);
        // loadChapter('_dev');


        // var urlScreenCaptureParam = fowtr_module_utilities.getUrlParameter('screenshot');
        // if(urlScreenCaptureParam){
        //   fowtr_module_utilities.disableFancyStuff = true;
        //   $('body').addClass('screenshot');
        //   $('#fowtr-wrapper .animate__inview').removeClass('animate__inview');
        // }


      });




      function waitForImages(callback){

        // $(document).ready(function () {
          // Images loaded is zero because we're going to process a new set of images.
          var imagesLoaded = 0;
          // Total images is still the total number of <img> elements on the page.
          var totalImages = $("#fowtr-wrapper img, .bgload").length;
          // console.log('totalImages',totalImages);
          // Step through each image in the DOM, clone it, attach an onload event
          // listener, then set its source to the source of the original image. When
          // that new image has loaded, fire the imageLoaded() callback.
          $("#fowtr-wrapper img").each(function (idx, img) {
            var src = $(img).attr("src");
            // console.log('loading image', src);
            $("<img>").on("load", imageLoaded).attr("src", src);
          });

          $(".bgload").each(function (idx, div) {
            var src = $(this).css('background-image');
            src = src.replace('url(','').replace(')','').replace(/\"/gi, "");
            // console.log('bgload',src);
            // var src = $(img).attr("src");
            $("<img>").on("load", imageLoaded).attr("src", src);
          });


          // Do exactly as we had before -- increment the loaded count and if all are
          // loaded, call the allImagesLoaded() function.
          function imageLoaded() {
            imagesLoaded++;

            var pc = (imagesLoaded / totalImages) * 100;
            if(pc>100) pc = 100;
            $('#fowtr-loading .fowtr-loading-progress-bar').css('width',pc+'%');
            if (imagesLoaded == totalImages) {
              allImagesLoaded();
            }
          }

          function allImagesLoaded() {
            // console.log("all image loaded");
            callback();
          }

          //incase there are no images at all...
          if (totalImages==0) callback();

        // })
      }

      function loadChapter(chapter,section){
        isLoading = true;
        
        //destroy stuff
        eval('fowtr_module_chapter_'+currentChapter+'.destroy(currentChapter);');
        fowtr_module_analytics.destroy(currentChapter);

        // fowtr_module_utilities.disableScroll();
        $('#fowtr-loading .fowtr-loading-progress-bar').css('width',0);

        $('#fowtr-loading').fadeIn('fast',function(){
        loadingTextCycle();

          $('#fowtr-content').load('https://local.dhl-future-of-work-trend-report.com/fowtr-ch'+chapter+'.html', function(response, status, xhr) {  // callback function 
            // console.log(status);

              // destroy chapter
              // eval('fowtr_module_chapter_'+chapter+'.destroy(chapter);');


              if ( status == "error" ) {
                // var msg = "Sorry but there was an error: ";
                // $( "#error" ).html( msg + xhr.status + " " + xhr.statusText );
                $('#fowtr-loading').fadeOut();
                cycleText = false;
                console.warn('fowtr: Error loading content: ' + xhr.status + " " + xhr.statusText);
                // fowtr_module_utilities.enableScroll();

              } else if ( status == "success" ){
                // Loaded...
                // console.log('loading images...');
                waitForImages(function(){
                  // all images loaded
                  $(window).scrollTop(0); //important - jump to top!



                  






                  // =====================================================================================================================================
                  // SET STATIC HERE
                  // disables animations and video
                  // =====================================================================================================================================
                  fowtr_module_utilities.disableFancyStuff = true;
                  fowtr_module_utilities.disableFancyStuff = fowtr_module_utilities.getUrlParameter('static')=='true' ? true : false;



                  // =====================================================================================================================================
                  // =====================================================================================================================================
                  // INIT HERE
                  // =====================================================================================================================================
                  // =====================================================================================================================================
                  // console.log('initialising modules');

                  fowtr_module_analytics.init(chapter);
                  fowtr_module_general.init(chapter);
                  eval('fowtr_module_chapter_'+chapter+'.init(chapter);');
                  fowtr_module_modals.init(chapter);
                  fowtr_module_navigation.init(chapter);
                  fowtr_module_fullscreen.init(chapter);
                  fowtr_module_tutorial.init(chapter);
                  // fowtr_module_audio_player.init(chapter);
                  fowtr_module_read_aloud.init(chapter);


                  // url inbound jump to
                  var urlSectionParam = fowtr_module_utilities.getUrlParameter('section');
                  if(urlSectionParam!==false && urlParamsSectionHasJumped==false){

                      var hash = '#fowtr-article'+ urlSectionParam;
                      if($(hash).length){

                        var offset = 56+52; // with secondary nav
                        // if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')){
                        //   offset = 0;
                        // }
                        // if($(this).hasClass('with6pinned')){
                        //   offset = 218; // without secondary nav
                        //   offset = 218+52; // with secondary nav
                        // }

                        // if($(window).width() < 768){
                        //   offset = 56;
                        // }


                        var offset = 56+52; // with secondary nav
                        var sectionToGoTo = $(hash);
                        if(urlSectionParam>6){ // has pinned top section 6
                          offset = (108 + 106); // without secondary nav
                        }
                        // console.log(urlSectionParam);
                        if($(window).width() < 768){
                          offset = (56 + 98);
                        }
                        if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')){
                          offset = 0;
                          if(urlSectionParam>6){// has pinned top section 6
                            offset = 106;
                          }
                        }


                        var st = $(hash).offset().top-offset;
                        // TweenMax.to($('html, body'),0,{scrollTop:st,ease:Linear.easeNone,delay:0.5});

                        setTimeout(function(){
                          // console.log('st',st);
                          // TweenMax.to($('html, body'),0.8,{scrollTop:st,ease:Power2.easeInOut});
                          // TweenMax.to($('html, body'),0,{scrollTop:st,ease:Linear.easeNone});
                          // window.scrollTo({top:st,behavior:'smooth'});
                          window.scrollTo({top:st});

                        },1000);

                        urlParamsSectionHasJumped = true;
                      }

                  }


                  // jump to section based on chapter load param. e.g. internal links.
                  if(section!=null){
                    var offset = 56+52; // with secondary nav
                    var hash = '#fowtr-article'+ section;
                    var sectionToGoTo = $(hash);
                    if(urlSectionParam>6){ // has pinned top section 6
                      offset = (108 + 106); // without secondary nav
                    }
                    if($(window).width() < 768){
                      offset = (56 + 98);
                    }
                    if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')){
                      offset = 0;
                      if(urlSectionParam>6){// has pinned top section 6
                        offset = 106;
                      }
                    }
                    var st = $(hash).offset().top-offset;
                    setTimeout(function(){
                      window.scrollTo({top:st});
                    },500);
                  }




                  // console.log('loading GSAP plugin');
                  

                  // console.log('running...');

                  $('#fowtr-loading').fadeOut(function(){
                    isLoading = false;
                  });
                  cycleText = false;
                  $('.fowtr-load-chapter').removeClass('active');
                  $('.fowtr-load-chapter[data-fowtr-chapter="'+chapter+'"]').addClass('active');

                  // set scroll to top of fowtr wrapper - DISABLED looks crap and the 100vh on first one acocunts for header, so jumping to further down page ends up seeing article 2
                  // var ot = $('#fowtr-wrapper').offset().top;// - 56
                  // var scrollTop = $(window).scrollTop();
                  // if(scrollTop > ot) $(window).scrollTop(ot);

                  // var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                  fowtr_module_navigation.stickyNavStuff($(window).scrollTop());
                  // TweenMax.to($('html, body'),0.8,{scrollTop:ot,ease:Power2.easeInOut});




                  // var urlScreenCaptureParam = fowtr_module_utilities.getUrlParameter('screenshot');
                  if(fowtr_module_utilities.disableFancyStuff){
                    $.fn.removeClassRegex = function(regex) {
                      return $(this).removeClass(function(index, classes) {
                        return classes.split(/\s+/).filter(function(c) {
                          return regex.test(c);
                        }).join(' ');
                      });
                    };
                    $('body').addClass('screenshot');
                    // $('#fowtr-wrapper .animate__inview').removeClass('animate__inview');
                    $('#fowtr-wrapper [class*="animate__"]').removeClassRegex(/^animate__/).css('opacity',1);
                  }




                  currentChapter = chapter;
                });
              } else {
                $('#fowtr-loading').fadeOut();
                cycleText = false;
                console.warn('fowtr: Error loading content: ' + xhr.status + " " + xhr.statusText);
                // fowtr_module_utilities.enableScroll();
              }
              

          });

        });//end fadeIn callback


      }





      // ------------------------------------------------------------------------------------------------
      //fit the loading screen in the available height
      // ------------------------------------------------------------------------------------------------
      var isLoading = true;
      function fitLoadingScreen(scrollTop){
        var ot = $('#fowtr-wrapper').offset().top;
        if (scrollTop > ot){
          $('#fowtr-loading').addClass('fixed-top');
        } else {
          $('#fowtr-loading').removeClass('fixed-top');
          var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
          var et = $('#fowtr-wrapper').offset().top;
          var loaderHeight = windowHeight - (et - scrollTop);
          // console.log('loaderHeight',loaderHeight);
          // console.log('et',et);
          $('#fowtr-loading').height(loaderHeight);
          // 
        }
      }
      $(window).scroll(function(e){
        if(!isLoading) return;
        // console.log(isLoading);
        fitLoadingScreen($(this).scrollTop());
      });
      $(window).on('resize', function(){
        // if(!isLoading) return;
        fitLoadingScreen($(this).scrollTop());
      });
      fitLoadingScreen(0);

      // var fitLoadingScreenEvent = fowtr_module_utilities.debounce(function(){
      //   console.log('st',$(this).scrollTop());
      //   fitLoadingScreen($(this).scrollTop());
      // },500);
      // window.onresize = fitLoadingScreenEvent;
      // window.onscroll = fitLoadingScreenEvent;
      // fitLoadingScreen(0);








      // ------------------------------------------------------------------------------------------------
      // loading screen cycling text effect
      // ------------------------------------------------------------------------------------------------
      var cycleText;

      function loadingTextCycle(){
        cycleText = true;
        // var divs = $('div[class^="loading-message-"]').hide(),
        var divs = $('.fowtr-loading-message').hide(),
            i = 0;
        divs = randomArrayShuffle(divs);
            
        (function cycle() {
          if(!cycleText) return;
            divs.eq(i).fadeIn(100)
                      .delay(1000)
                      .fadeOut(200, cycle);
            i = ++i % divs.length;
        })();
      }

      function randomArrayShuffle(array) {
        var currentIndex = array.length, temporaryValue, randomIndex;
        while (0 !== currentIndex) {
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
        return array;
      }





      // var cycleTextInterval;
      // function loadingTextCycle(){
      //   // var divs = $('div[class^="loading-message-"]').hide(),
      //   var divs = $('.fowtr-loading-message').hide(),
      //       i = 0;
      //   randomArrayShuffle(divs);
        
      //   divs.eq(i).fadeIn(100);
      //   cycleTextInterval = setInterval(function(){
      //     divs.eq(i).fadeIn(100)
      //               .delay(800)
      //               .fadeOut(100);
      //     i = ++i % divs.length;
      //   },1000);
      // }





      // loadingTextCycle();


      // $('#fowtr-wrapper').on('click', '.a[data-fowtr-layout="full-screen"]', function(event) {
      //   event.preventDefault();

      //   elem = document.getElementById('fowtr-wrapper');
      //   // function openFullscreen() {
      //   if (elem.requestFullscreen) {
      //     elem.requestFullscreen();
      //   } else if (elem.webkitRequestFullscreen) { /* Safari */
      //     elem.webkitRequestFullscreen();
      //   } else if (elem.msRequestFullscreen) { /* IE11 */
      //     elem.msRequestFullscreen();
      //   }
      //   // }


      // });



});
